/* ============================================================
   Herb Terra cart JS.
   Loaded from cart-drawer.liquid (every page) + main-cart-*
   sections (cart page).
   - Customer attribute bridge (writes htc_customer_* to cart.attributes
     so Checkout UI Extensions can read via useAttributeValues)
   - Animation hooks on quantity change
   ============================================================ */

(function () {
  'use strict';

  if (window.__htCartJsLoaded) return;
  window.__htCartJsLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // --- 1. Cart attribute bridge: write personalisation keys ----

  function deriveTier(orders, hasSubscription) {
    if (hasSubscription && orders >= 2) return 'subscriber';
    if (orders >= 5) return 'insider';
    if (orders >= 1) return 'returning';
    return 'guest';
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function setAttributes(attrs) {
    var body = { attributes: attrs };
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function writeCustomerAttributes() {
    var c = window.HerbTerraCustomer || {};

    getCart().then(function (cart) {
      var hasSubscription = (cart.items || []).some(function (i) { return i.selling_plan_allocation != null; });
      var tier = deriveTier(c.ordersCount || 0, hasSubscription);

      var current = cart.attributes || {};
      var next = {
        htc_customer_first_name: c.firstName || '',
        htc_customer_tier: tier,
        htc_customer_orders_count: String(c.ordersCount || 0),
        htc_market: c.market || 'SG',
        htc_has_subscription: hasSubscription ? 'true' : 'false'
      };

      var diff = false;
      Object.keys(next).forEach(function (k) {
        if (current[k] !== next[k]) diff = true;
      });

      if (!diff) return;
      setAttributes(next).catch(function () { /* non-fatal */ });
    }).catch(function () { /* non-fatal */ });
  }

  // --- 2. Subscription pill on cart-item lines ----------------

  function markSubscriptionLines() {
    document.querySelectorAll('cart-drawer .cart-item, .cart-items .cart-item').forEach(function (row) {
      var hasPlan = !!row.querySelector('.cart-item__details .product-option:last-of-type');
      // Only flag when there's a selling plan: rely on Liquid rendering the
      // plan name in that final .product-option. Skip if no dl is present
      // (no variant options + no plan).
      var hasDl = !!row.querySelector('.cart-item__details dl');
      var lastOpt = row.querySelector('.cart-item__details > p.product-option:last-child');
      if (hasDl && lastOpt) {
        row.classList.add('cart-item--subscription');
      }
    });
  }

  // --- 3. Loading state on qty change -------------------------

  function bindQuantityLoading() {
    document.querySelectorAll('cart-drawer .quantity__input, .cart-items .quantity__input').forEach(function (input) {
      if (input.__htBound) return;
      input.__htBound = true;
      input.addEventListener('change', function () {
        var row = input.closest('.cart-item');
        if (row) row.classList.add('is-loading');
      });
    });
  }

  // --- 4. Listen for cart updates (Dawn PUB_SUB pattern) ------

  // Update the drawer heading "(N)" count. Used as a client-side fallback
  // because Shopify's section-render cache can serve stale Liquid for the
  // drawer for several minutes after a snippet update.
  function updateHeadingCount() {
    getCart().then(function (cart) {
      var heading = document.querySelector('cart-drawer .drawer__heading');
      if (!heading) return;
      var n = cart.item_count || 0;
      var existing = heading.querySelector('.drawer__heading-count');
      if (n > 0) {
        if (!existing) {
          existing = document.createElement('span');
          existing.className = 'drawer__heading-count';
          heading.appendChild(document.createTextNode(' '));
          heading.appendChild(existing);
        }
        existing.textContent = '(' + n + ')';
        existing.setAttribute('aria-label', n + ' items in cart');
      } else if (existing) {
        existing.remove();
      }
    }).catch(function () { /* non-fatal */ });
  }

  function subscribeToCartUpdates() {
    // Dawn fires custom event on the cart-items / cart-drawer-items components
    document.addEventListener('cart:refresh', function () {
      writeCustomerAttributes();
      updateHeadingCount();
    });

    // Patch into Dawn's publish-subscribe if it's available
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        writeCustomerAttributes();
        markSubscriptionLines();
        bindQuantityLoading();
        updateHeadingCount();
      });
    }
  }

  // --- 5. Hide on-page chat widgets while drawer is open -------
  // The Herb Terra chatbot (Jack) renders at z-index 99999 with the IDs
  // #ht-nudge, #ht-launcher, #ht-panel. It otherwise covers the drawer
  // footer/CTA. Toggle visibility directly via JS so the CTA is reachable.

  var CHATBOT_IDS = ['ht-nudge', 'ht-launcher', 'ht-panel', 'vercel-chat-button'];
  var CHATBOT_PRIOR = {};

  function hideChatWidgets() {
    CHATBOT_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (CHATBOT_PRIOR[id] == null) CHATBOT_PRIOR[id] = el.style.display || '';
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('data-htc-drawer-hid', 'true');
    });
  }

  function restoreChatWidgets() {
    CHATBOT_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.hasAttribute('data-htc-drawer-hid')) return;
      el.style.removeProperty('display');
      if (CHATBOT_PRIOR[id]) el.style.display = CHATBOT_PRIOR[id];
      el.removeAttribute('data-htc-drawer-hid');
    });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    function reactToState() {
      if (drawer.classList.contains('active')) {
        hideChatWidgets();
        updateHeadingCount();
      } else {
        restoreChatWidgets();
      }
    }

    new MutationObserver(reactToState).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also hide on any future chatbot mount (e.g. delayed script load).
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) hideChatWidgets();
    }).observe(document.body, { childList: true, subtree: false });

    reactToState();
  }

  // --- Bootstrap ---------------------------------------------

  function init() {
    markSubscriptionLines();
    bindQuantityLoading();
    writeCustomerAttributes();
    subscribeToCartUpdates();
    updateHeadingCount();
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
